/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Optional initial status.
 */
export const CreateTriggerInstanceFormStatus = {
  Active: "active",
  Paused: "paused",
} as const;
/**
 * Optional initial status.
 */
export type CreateTriggerInstanceFormStatus = ClosedEnum<
  typeof CreateTriggerInstanceFormStatus
>;

/**
 * The trigger target kind.
 */
export const CreateTriggerInstanceFormTargetKind = {
  Assistant: "assistant",
  Noop: "noop",
} as const;
/**
 * The trigger target kind.
 */
export type CreateTriggerInstanceFormTargetKind = ClosedEnum<
  typeof CreateTriggerInstanceFormTargetKind
>;

export type CreateTriggerInstanceForm = {
  /**
   * The trigger config payload.
   */
  config: { [k: string]: any };
  /**
   * The trigger definition slug.
   */
  definitionSlug: string;
  /**
   * The linked environment ID.
   */
  environmentId?: string | undefined;
  /**
   * The trigger instance name.
   */
  name: string;
  /**
   * Optional initial status.
   */
  status?: CreateTriggerInstanceFormStatus | undefined;
  /**
   * The user-facing target display value.
   */
  targetDisplay: string;
  /**
   * The trigger target kind.
   */
  targetKind: CreateTriggerInstanceFormTargetKind;
  /**
   * The opaque target reference.
   */
  targetRef: string;
};

/** @internal */
export const CreateTriggerInstanceFormStatus$outboundSchema: z.ZodMiniEnum<
  typeof CreateTriggerInstanceFormStatus
> = z.enum(CreateTriggerInstanceFormStatus);

/** @internal */
export const CreateTriggerInstanceFormTargetKind$outboundSchema: z.ZodMiniEnum<
  typeof CreateTriggerInstanceFormTargetKind
> = z.enum(CreateTriggerInstanceFormTargetKind);

/** @internal */
export type CreateTriggerInstanceForm$Outbound = {
  config: { [k: string]: any };
  definition_slug: string;
  environment_id?: string | undefined;
  name: string;
  status?: string | undefined;
  target_display: string;
  target_kind: string;
  target_ref: string;
};

/** @internal */
export const CreateTriggerInstanceForm$outboundSchema: z.ZodMiniType<
  CreateTriggerInstanceForm$Outbound,
  CreateTriggerInstanceForm
> = z.pipe(
  z.object({
    config: z.record(z.string(), z.any()),
    definitionSlug: z.string(),
    environmentId: z.optional(z.string()),
    name: z.string(),
    status: z.optional(CreateTriggerInstanceFormStatus$outboundSchema),
    targetDisplay: z.string(),
    targetKind: CreateTriggerInstanceFormTargetKind$outboundSchema,
    targetRef: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      definitionSlug: "definition_slug",
      environmentId: "environment_id",
      targetDisplay: "target_display",
      targetKind: "target_kind",
      targetRef: "target_ref",
    });
  }),
);

export function createTriggerInstanceFormToJSON(
  createTriggerInstanceForm: CreateTriggerInstanceForm,
): string {
  return JSON.stringify(
    CreateTriggerInstanceForm$outboundSchema.parse(createTriggerInstanceForm),
  );
}
